import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChatStore } from 'store/chat.store';
import { AiMonogram } from './AiMonogram';

interface CustomChatLoadingProps {
  visible?: boolean;
}

/** "AI · O'ylamoqda…" until the answer's first token lands. Stopping lives in the composer only. */
const CustomChatLoading: React.FC<CustomChatLoadingProps> = ({ visible = true }) => {
  const { t } = useTranslation();
  const { isStreaming } = useChatStore();

  if (!isStreaming || !visible) return null;

  return (
    <div role="status" className="flex items-center gap-2.5 text-[13.5px] text-muted-foreground">
      <AiMonogram />
      <span>{t('thinking')}</span>
    </div>
  );
};

export default CustomChatLoading;
